import { render, staticRenderFns } from "./facebookIcon.vue?vue&type=template&id=646917e4&scoped=true&"
import script from "./facebookIcon.vue?vue&type=script&lang=ts&"
export * from "./facebookIcon.vue?vue&type=script&lang=ts&"
import style0 from "./facebookIcon.vue?vue&type=style&index=0&id=646917e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646917e4",
  null
  
)

export default component.exports